import { render, staticRenderFns } from "./PackagesFno.vue?vue&type=template&id=c4cb704c&"
import script from "./PackagesFno.vue?vue&type=script&lang=js&"
export * from "./PackagesFno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports